// ACC-523: themed replacements for the .fd-* typography utility classes that
// lived in index.css. Each emits the matching font shorthand from the theme.
import styled from 'styled-components';

export const Heading1 = styled.h1`
	font: ${p => p.theme.ticketing.font.heading1};
	margin: 0;
`;
export const Heading2 = styled.h2`
	font: ${p => p.theme.ticketing.font.heading2};
	margin: 0;
`;
export const Heading3 = styled.h3`
	font: ${p => p.theme.ticketing.font.heading3};
	margin: 0;
`;
export const Heading4 = styled.h4`
	font: ${p => p.theme.ticketing.font.heading4};
	margin: 0;
`;
export const Subheading1 = styled.p`
	font: ${p => p.theme.ticketing.font.subheading1};
	letter-spacing: 0.15px;
	margin: 0;
`;
export const Subheading2 = styled.p`
	font: ${p => p.theme.ticketing.font.subheading2};
	letter-spacing: 0.15px;
	margin: 0;
`;
export const Label1 = styled.span`
	font: ${p => p.theme.ticketing.font.label1};
	margin: 0;
`;
export const Body2 = styled.p`
	font: ${p => p.theme.ticketing.font.body2};
	margin: 0;
`;
export const Body3 = styled.p`
	font: ${p => p.theme.ticketing.font.body3};
	margin: 0;
`;
export const Overline = styled.span`
	font: ${p => p.theme.ticketing.font.overline};
	text-transform: uppercase;
	letter-spacing: 0.08em;
	margin: 0;
`;
